import {CSRF_TOKEN, URL_PREFIX} from "../constants";

/**
 * Функция запроса к серверу
 * @param {Object} params - параметры запроса
 * @param {String} params.url
 * @param {Boolean} [params.addCSRFToken]
 * @param {Object} [params.data]
 * @param {Boolean} [params.async]
 * @param {('POST' | 'GET' | 'DELETE')} [params.type=POST]
 * @param {Number} [params.timeout]
 * @param {Boolean} [params.needOverlay=true]
 * @param {Boolean} [params.parseJSON]
 * @return {Promise}
 */
export default params => {
	/* по умолчанию показываем прелоадер */
	if (params.needOverlay !== false) params.needOverlay = true;

	/* Если определен URL_PREFIX То добавить префикс перед url */
	if (URL_PREFIX) params.url = URL_PREFIX + params.url;

	/* Если надо передать токен */
	if (params.addCSRFToken && params.data) params.data["_csrf-frontend"] = CSRF_TOKEN;

	return new Promise((succeed, fail) => {
		$.ajax({
			url: params.url,
			data: params.data || null,
			async: params.async || true,
			type: params.type || "POST",
			timeout: params.timeout || 40000,
			beforeSend: () => {
				if (params.needOverlay) return $("#js-overlay").show();
			},
			success: response => {
				if (!response) return succeed();
				if (params.parseJSON === false) return succeed(response);

				try {
					succeed(JSON.parse(response));
				} catch (e) {
					succeed(response);
				}
			},
			error: error => fail(error.responseJSON),
			complete: () => {
				if (params.needOverlay) return $("#js-overlay").hide();
			},
		});
	});
};
